import _extends from 'babel-runtime/helpers/extends';
import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  .react-datepicker__day-names {\n    display: none;\n  }\n'], ['\n  .react-datepicker__day-names {\n    display: none;\n  }\n']);

import React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import styled from 'styled-components';

var Container = styled.div(_templateObject);

// we just need dates which aren't a leap year here
var MIN_DATE = moment(new Date('2018-01-01'));
var MAX_DATE = moment(new Date('2018-12-31'));

var YearlyInput = function YearlyInput(_ref) {
  var value = _ref.value,
      _onChange = _ref.onChange;
  var month = value.month,
      day = value.day;

  var date = moment(new Date('2018-' + month + '-' + day));
  return React.createElement(
    Container,
    null,
    React.createElement(DatePicker, {
      inline: true,
      dateFormatCalendar: 'MMMM',
      minDate: MIN_DATE,
      maxDate: MAX_DATE,
      selected: date,
      onChange: function onChange(date) {
        return _onChange(_extends({}, value, { month: date.month() + 1, day: date.date() }));
      }
    })
  );
};

export default YearlyInput;
//# sourceMappingURL=YearlyInput.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/fields/When/RecurrencyDetails/components/YearlyInput.js
// module id = 1114
// module chunks = 0